<template>
	<sf-content-layout>
		<template v-slot:title>
			<sf-content-title :title="scrTitle" />
		</template>
		<template v-slot:button>
			<sf-button size="lg" color="default" :line="false" className="sf-button--black-light" :action="Save">Save</sf-button>
		</template>
		<template v-slot:content>
			<component :is="componentLoader" v-bind="{ scrId: oriScrId, mainKey, blankScrId }"></component>
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' },
		oriScrId: { type: String, default: '' },
		scrTitle: { type: String, default: '' },
		mainKey: { type: String, default: '' },
		blankScrId: { type: String, default: '' },
		contentComponent: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		//console.clear();
		// console.log('black', this.mainKey);
		this.screen = this.screenArray.get(this.oriScrId);
	},
	methods: {
		...rootMethods
	},
	computed: {
		...rootComputed,
		componentLoader() {
			return () => import('@/views' + this.contentComponent).catch(error => {});
		}
	}
};
</script>

<style></style>
